import {
  PaginatedReturnOpportunityProductListReadable,
  ReturnProductReadable
} from '@crm/api'
import { FormInstance } from 'antd'

export const setProductDefaults = (
  form: FormInstance,
  option: ReturnProductReadable,
  opportunityProducts:
    | PaginatedReturnOpportunityProductListReadable
    | undefined,
  currentRowId?: number,
  isFirstProduct = false
) => {
  const { uom, price, currency, id: productId } = option

  const usedNow =
    opportunityProducts?.results
      ?.filter((p) => p.product?.id === productId && p.id !== currentRowId)
      ?.map((p) => p.uom?.id) || []

  form.setFieldValue('custom_price', price)
  form.setFieldValue('quantity', 1)

  if (isFirstProduct && currency?.id) {
    form.setFieldValue('currency', currency.id)
  }

  if (uom?.id && !usedNow.includes(uom.id)) {
    form.setFieldValue('uom', uom.id)
  } else {
    form.setFieldValue('uom', undefined)
  }
}
